function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { extendTheme } from '@chakra-ui/react';
import { breakpoints } from "./breakpoints";
import { colors } from "./colors";
import { components } from "./components";
import { config } from "./config";
import { radii } from "./radii";
import { shadows } from "./shadows";
import { sizes } from "./sizes";
import { space } from "./space";
import { styles } from "./styles";
import { textStyles } from "./textStyles";
import { typography } from "./typography"; // chakra 1.6.7 loosened `extendTheme`'s typings making it so you can't derive the final type of your theme from it
// as a workaround, we merge the base theme type with our custom overrides

var overrides = _extends({
  breakpoints,
  colors,
  components,
  config,
  radii,
  shadows,
  sizes,
  space,
  styles,
  textStyles
}, typography);

export var theme = extendTheme(overrides);
//# sourceMappingURL=theme.js.map